import { httpRequest } from "@/utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/AppTypes";

//详情
export interface ICustomerDetail {
    source: any;
    id: string,
    code: string,
    name: string,
    orgCode?: string,
    orgName?: string,
    shopCode?: string,
    shopId?: string,
    shopName?: string,
    categoryCode?: string,
    categoryName?: string,
    level?: string,
    contact?: string,
    phone?: string,
    tel?: string,
    fax?: string,
    email?: string,
    website?: string,
    address?: string,
    invoiceTitle?: string,
    licenseNo?: string,
    bank?: string,
    acctHolder?: string,
    bankAcct?: string,
    note?: string,
    taxNo?: string,
    postAddress?: string,
    corporation?: string,
    bankPhone?: string,
    businessScope?: string,
    status?: string | boolean,
    isInternal?: string,
    linkCode?: string,
    staffCode?: string,
    staffName?: string,
    attrCode?: string,
    attrName?: string,
    countryCode?: string,
    countryName?: string,
    contractStartTime?: string
    contractEndTime?: string
    qualifications?: string
    enable?: string,
    createTime?:any,
    updateTime:any
}
//新增
export interface ICustomerInsert extends ICustomerDetail {

}

//编辑
export interface ICustomerUpdate extends ICustomerInsert {
    id: string,
}
//搜索条件
export interface ICustomerSearchFields {
    [key: string]: any
}

export interface ICustomerSearch
    extends ICustomerSearchFields, ISearchPage {

}

class CustomerService {
    async page(searchVo: ICustomerSearch, config: object = {}) {
        const apiUrl = "/gtm/base/customer/listPage";
        return await httpRequest.post<IPage<ICustomerDetail>>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        let shopCode = JSON.parse(sessionStorage.getItem("gtm.user") || "{}").shopCode;
        const apiUrl = `/gtm/base/customer/findById/${id}/${shopCode}`;
        return await httpRequest.get<ICustomerDetail>(apiUrl);
    }
    async insert(insertVo: ICustomerInsert) {
        const apiUrl = "/gtm/base/customer/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: ICustomerUpdate) {
        const apiUrl = "/gtm/base/customer/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //启用禁用
    async disable(obj: any) {
        // const apiUrl = `/gtm/base/customer/enableOrDisable/${id}/${status}`;
        const apiUrl = `/gtm/base/customer/enableOrDisable`;
        return await httpRequest.post<boolean>(apiUrl, obj);
    }
    //导出
    async export(searchVo: ICustomerSearch) {
        const appPageUrl = "/gtm/base/customer/export";
        return await httpRequest.postFile(appPageUrl, searchVo, { timeout: 300000 });
    }

    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/base/customer/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
}

export const customerService = new CustomerService();
